import React from 'react';
import { Box, Typography } from '@mui/material';

export default function SectionTitle({ children, descricao }) {
    return (
        <Box sx={{ mb: descricao ? 2 : 3 }}>
            <Typography variant="h6" sx={{ color: '#1ABB9C', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ width: 4, height: 24, bgcolor: '#1ABB9C', borderRadius: 1 }} />
                {children}
            </Typography>
            {descricao && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1, ml: 1.5 }}>
                    {descricao}
                </Typography>
            )}
        </Box>
    );
}
